<template>
  <div class="wrap">
    <iframe
      class="frame"
      src="/files/UNSUNG_PRIVACY_POLICY.pdf#toolbar=0&navpanes=0&scrollbar=1"
    ></iframe>
  </div>
</template>

<style scoped>
.wrap {
  position: fixed;
  inset: 0;
}

.frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>